import { __awaiter, __generator } from "tslib";
import { isExternalModule, launchModuleById } from './launchModuleById';
export function launchEventHandler(launchEvent) {
    return __awaiter(this, void 0, void 0, function () {
        var data, launchOut, additionalParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = launchEvent.data && launchEvent.data();
                    if (!data) return [3 /*break*/, 4];
                    launchOut = !!data.launchOut;
                    if (!!launchOut) return [3 /*break*/, 2];
                    return [4 /*yield*/, isExternalModule(data.tileID, data.platformType)];
                case 1:
                    // Even if we're not explicitly launching out, there are still
                    // various conditions where we want to launch out anyways, for
                    // tiles that do not have an inline experience.
                    if (_a.sent()) {
                        launchOut = true;
                    }
                    _a.label = 2;
                case 2:
                    additionalParams = {};
                    if (data.tilePosition != null) {
                        additionalParams["TilePosition" /* InstrumentationParam.TilePosition */] =
                            data.tilePosition.toString();
                    }
                    if (data.tileHostContext != null) {
                        additionalParams["TileHostContext" /* InstrumentationParam.TileHostContext */] =
                            data.tileHostContext;
                    }
                    return [4 /*yield*/, launchModuleById(data.tileID, data.platformType, launchEvent.type, launchOut, additionalParams)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=launchEventHandler.js.map